import { getField, updateField } from 'vuex-map-fields';
import AdminService from '@/services/AdminService';

const getDefaultState = function () {
    return {
        id: null,
        title: null,
        subtitle: null,
        author: null,
        link: null,
        imageUrl: null,
        status: null
    };
};

/* eslint no-shadow: ["error", { "allow": ["state"] }] */
const state = getDefaultState();

const getters = {
    getField,
    form: (state) => ({
        id: state.id,
        title: state.title,
        subtitle: state.subtitle,
        author: state.author,
        link: state.link,
        imageUrl: state.imageUrl,
        status: state.status
    }),
};

const mutations = {
    setBank(state, value) {
        if (value) {
            // value.Transfers.forEach((status) => {
            //     status.Events.sort((a, b) => new Date(a.Date) - new Date(b.Date));
            // });
            Object.assign(state, value);
        } else {
            Object.assign(state, getDefaultState());
        }
    },

    storeReportDetails(state, data) {
        Object.assign(state, data);
    },
    updateField,
};

const actions = {
    async loadBook({ commit }, data) {
        // const course = JSON.parse(localStorage.getItem('course'));
        const res = await AdminService.getBooksInBank({
            EntityId: data.id
        });
        commit('setBank', res.data.items[0]);
        return res.data;
    },
    async loadBookAdmin({ commit }, data) {
        const res = await AdminService.getBooksInBank(data.id);
        commit('setBank', res.data);
        return res.data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
